var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-main-100"},[(_vm.pageData)?_c('CmsPageConstructor',{attrs:{"page-url":_vm.url,"cms-data":_vm.pageData}}):_c('v-progress-linear',{attrs:{"height":"2","indeterminate":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }